export default __webpack_public_path__ + "static/Recreation-388f84bf98e2f334d778387371bdbfc8.png";